import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DailyIframe from "@daily-co/daily-js";
import { ErrorState, Spinner } from "@/components/common";
import { api, apiError } from "@/lib/api";

export default function Call() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const box = useRef(null);
  const [session, setSession] = useState(state?.call_id === id ? state : null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (session) return;
    api.post(`/calls/${id}/join`).then(({ data }) => setSession(data)).catch((e) => setError(apiError(e)));
  }, [id, session]);

  useEffect(() => {
    if (!session || !box.current) return undefined;
    let frame = null;
    let cancelled = false;
    const leave = () => { api.post(`/calls/${id}/end`).catch(() => {}); navigate(session.experience_id ? `/experiences/${session.experience_id}` : "/connect"); };
    (async () => {
      const existing = DailyIframe.getCallInstance();
      if (existing) await existing.destroy().catch(() => {});
      if (cancelled || !box.current) return;
      frame = DailyIframe.createFrame(box.current, {
        showLeaveButton: true, iframeStyle: { width: "100%", height: "100%", border: "0", borderRadius: "12px" },
      });
      frame.on("left-meeting", leave);
      frame.on("error", () => setError("The call was interrupted. Please try again."));
      frame.join({ url: session.room_url, token: session.token, startVideoOff: !!session.voice }).catch(() => setError("The call couldn't be joined or has ended."));
    })();
    return () => {
      cancelled = true;
      if (frame) { frame.off("left-meeting", leave); frame.destroy().catch(() => {}); }
    };
  }, [session, id, navigate]);

  if (error) return <div className="shell py-16"><ErrorState message={error} /></div>;
  return (
    <div className="shell pb-24 pt-6" data-testid="call-page">
      <p className="eyebrow" data-testid="call-label">{session?.experience_id ? "Group planning call · up to 30 minutes · not recorded" : `Private ${session?.voice ? "voice" : "video"} call · up to 30 minutes · not recorded`}</p>
      <div ref={box} className="mt-4 h-[70vh] min-h-[420px] w-full overflow-hidden rounded-xl border border-border bg-black" data-testid="call-frame">
        {!session && <Spinner />}
      </div>
    </div>
  );
}
